import { PROJECT_TASKS_CRUD_ACTION_CREATORS } from '../actions/project_tasks_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';

// Real backend: /api/v1/{buyer|supplier}/project/project_tasks
// (openwrench-app claude/project-deliverables-tasks). List filters by
// projectId / deliverableId.
export const projectTasksRestCrudThunksForBuyer = new RestCrudThunks(
	'project_tasks',
	'project_task',
	'projectTask',
	'projectTasks',
	PROJECT_TASKS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'project/'
);

export const projectTasksRestCrudThunksForSupplier = new RestCrudThunks(
	'project_tasks',
	'project_task',
	'projectTask',
	'projectTasks',
	PROJECT_TASKS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'project/'
);
